
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="题目类型：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科目类别：">
                <el-select style="width: 100px;" size="small" v-model="formInline.subject" placeholder="请选择">
                    <el-option v-for="type in subject" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分类展示：">
                <el-select style="width: 100px;" size="small" v-model="formInline.is_place" placeholder="请选择">
                    <el-option v-for="type in is_place" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分类名称：">
                <el-input size="small" v-model="formInline.classify" placeholder="请输入分类名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>
        </el-form>


        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="40">
            </el-table-column>
            <el-table-column prop="pcid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="type" label="题目类型" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.type == 0">小车</div>
                    <div v-else-if="row.type == 1">货车</div>
                    <div v-else-if="row.type == 2">客车</div>
                    <div v-else>摩托车</div>
                </template>
            </el-table-column>
            <el-table-column prop="subject" label="科目类别" width="80">
                <template slot-scope="{row}">
                    <div v-if="row.subject == 0">科目一</div>
                    <div v-else>科目四</div>
                </template>
            </el-table-column>
            <el-table-column prop="classify" label="分类名称" width="180">
            </el-table-column>
            <el-table-column prop="is_place" label="分类展示" width="100" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div v-if="row.is_place == 0">分类练习</div>
                    <div v-else-if="row.is_place == 1">精选练习</div>
                    <div v-else-if="row.is_place == 2">地方专题</div>
                    <div v-else-if="row.is_place == 3">扣12分 </div>
                    <div v-else-if="row.is_place == 4">免费试用</div>
                    <div v-else>暂无</div>
                </template>
            </el-table-column>
            <el-table-column prop="image" label="分类图标" width="80" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.image" class="table_list_pic" :src="scope.row.image"
                            :preview-src-list="[scope.row.image]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="auto">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="adds(scope.row)"><i
                            class="el-icon-plus" />批量分配题目</el-button>
                    <el-button size="mini" type="primary" @click="update(scope.row)"><i
                            class="el-icon-edit" />修改</el-button>
                    <el-button size="mini" type="primary" @click="details(scope.row)"><i
                            class="el-icon-edit" />查看</el-button>
                    <el-button size="mini" type="danger" @click="del(scope.row)"><i class="el-icon-delete" />删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"> </Add>
        <Adds :info="updateInfo1" :show.sync="dialog.addsDialogStatus" @refesh_list="getdata"> </Adds>
        <Details :show.sync="dialog.detailsDialogStatus" :userid="userid"></Details>
        <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
    </div>
</template>
  
<script>
import { getclassifyindex, getclassifydel, getclassifyedit } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Add from './add.vue'
import Adds from './adds.vue'
import Details from './details.vue'

import Update from './update.vue'
export default {
    // 注册组件
    components: {
        Pagination, Add, Update, Adds, Details
    },
    data() {
        return {
            subject: [
                { key: '请选择', value: '' },
                { key: '科目一', value: 0 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '请选择', value: '' },
                { key: '小车', value: 0 },
                { key: '货车', value: 1 },
                { key: '客车', value: 2 },
                { key: '摩托车', value: 3 },
            ],
            is_place: [
                { key: '请选择', value: '' },
                { key: '分类练习', value: 0 },
                { key: '精选练习', value: 1 },
                { key: '地方专题', value: 2 },
                { key: '扣12分', value: 3 },
                { key: '免费试用', value: 4 },
            ],
            dialog: {
                addDialogStatus: false,
                updateDialogStatus: false,
                addsDialogStatus: false,
                detailsDialogStatus: false
            },
            breadcrumbList: [],
            updateInfo: {},
            updateInfo1: {},
            loading: false, //是显示加载
            formInline: {
                classify: '',
                number: '',
                subject: '',
                is_place: '',
                type: '',
                limit: 10,
                page: 1
            },
            userid: 0,
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    created() {
        this.getdata()
        this.generateBreadcrumb()
    },
    watch: {
        $route() {
            this.generateBreadcrumb()
        }
    },
    methods: {
        //添加题目
        add() {
            this.dialog.addDialogStatus = true
        },
        adds(row) {
            this.dialog.addsDialogStatus = true
            this.updateInfo1 = row
        },
        details(row) {
            this.userid = row.pcid * 1
            this.dialog.detailsDialogStatus = true
        },
        //修改题目
        update(row) {
            getclassifyedit({ pcid: row.pcid, echo: 'get' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.updateDialogStatus = true
                    this.updateInfo = res.classify
                }
            })
        },
        search() {
            this.formInline.page = 1
            this.getdata(this.formInline)
        },
        del(row) {
            this.$confirm('确定要删除吗?', '信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getclassifydel({ pcid: row.pcid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        generateBreadcrumb() {
            // 获取当前路由信息
            const matched = this.$route.matched
            console.log(matched, '++++++++++');
            // 初始化面包屑导航数据
            const breadcrumbList = []
            // 遍历路由信息，生成面包屑导航数据
            matched.forEach(item => {
                const { meta, name, path } = item
                if (meta.requireAuth) {
                    breadcrumbList.push({
                        name,
                        path
                    })
                }
            })
            console.log(breadcrumbList, '=========');
            // 保存面包屑导航数据
            this.breadcrumbList = breadcrumbList
        },
        getdata() {
            this.loading = true
            getclassifyindex(this.formInline).then(res => {
                console.log(res);
                if (res) {
                    this.listData = res.classify.data
                    this.pageparm.total = res.classify.total
                    this.loading = false

                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
  
<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/group/index.vue